@if (isLoading) {
  <div class="flex justify-center items-center h-full">
    <p-progressSpinner />
  </div>
}

<div class="p-4 queue-table">
  @if (!isLoading) {
    <div class="mb-2">
      <app-queue-action-buttons
        (resetData)="reload()"
        (clear)="clear()">
        <div class="flex gap-4 items-center" queue-action>
          <div>Filter by Pending PL Status Reason</div>
          <p-multiSelect
            placeholder="Filter"
            appendTo="body"
            optionLabel="description"
            styleClass="w-80"
            [options]="statusReasons"
            [(ngModel)]="selectedStatusReasons"
            (onChange)="setFilterStatusReasons($event.value)"
            />
          </div>
        </app-queue-action-buttons>
      </div>
    }
    <mnc-dmepos-queue
      #queue
      lazyComponent
      [lineOfBusiness]="stringifiedLineOfBusiness"
      [tenants]="stringifiedTenants"
      (routerEvents)="handleRouterEvents($event)">
    </mnc-dmepos-queue>
  </div>
